import {
  FETCH_ALL_MYCOINS_TRANSACTIONS_SUCCESS,
  DOWNLOAD_MYCOINS_TRANSACTIONS
} from '../constant/actionType';

const initialState = {
  allTransactions: [],
  csv: null
};

const myCoinsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_MYCOINS_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        allTransactions: action.data
      };

    case DOWNLOAD_MYCOINS_TRANSACTIONS:
      return {
        ...state,
        csv: action.data
      };

    default:
      return state;
  }
};

export default myCoinsReducer;
